module.exports = {
    "page.import.historyBox.col.type": "File Name",
    "page.import.importBox.importButton": "Upload Files",
    "page.import.importBox.importModeText": "Import Mode",
    "page.import.tab.history": "Import History",
    "page.import.historyBox.col.progress": "Progress",
    "page.import.importBox.infos.3": "Encoding format: UTF-8, separator: semicolon",
    "page.import.historyBox.feedback.success": "Your import is finished",
    "page.import.importBox.infos.2": "Note: the Excel file may not contain any formulas or references.",
    "page.import.historyBox.col.user": "User",
    "page.import.importBox.infos.1": "To create or upload products you can use CSV files (.csv) or MS Excel documents (.xlsx).",
    "page.import.tab.template": "Template History",
    "page.import.historyBox.feedback.failed": "Your import is failed",
    "page.import.historyBox.col.action": "Action",
    "page.import.historyBox.col.processed": "Processed",
    "page.import.tab.import": "Import",
    "page.import.historyBox.col.status": "Status",
    "page.import.historyBox.col.created": "Created",
    "page.import.importBox.templateTitle": "Download Templates",
    "page.import.footer.button.done": "Done",
    "page.import.footer.button.another": "Import Another",
    "page.import.historyBox.link.download": "Download"
};